import Footer from 'components/layout/footer';
import NavBar from 'components/layout/navbar';
import React from 'react';
import WeElevateFAQ from './WeElevateFAQ';
import Hero from './Hero';
import { Helmet } from 'react-helmet-async';

export default function WeElevate() {
  return (
    <>
      <Helmet>
        {/* ---------- Basic SEO ---------- */}
        <title>
          WE-Elevate Nigeria | Empowering Women Entrepreneurs | Shecluded
        </title>
        <meta
          name="description"
          content="WE-Elevate Nigeria empowers women-led MSMEs with digital, financial, and entrepreneurial skills to scale globally. Apply now to join the next cohort."
        />
        <meta
          name="keywords"
          content="WE-Elevate Nigeria, weelevate, We-elevate, we-elevate, weelevate shecluded, we-elevate shecluded, women entrepreneurs, MSME training, digital skills, women in business, women empowerment program, Shecluded, NITDA, DCO"
        />
        <meta name="author" content="Shecluded" />
        <link rel="canonical" href="https://shecluded.com/we-elevate" />

        {/* ---------- Open Graph (Facebook, LinkedIn, WhatsApp) ---------- */}
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_NG" />
        <meta property="og:url" content="https://shecluded.com/we-elevate" />
        <meta
          property="og:title"
          content="WE-Elevate Nigeria | Empowering Women Entrepreneurs | Shecluded"
        />
        <meta
          property="og:description"
          content="Empowering women-led MSMEs with the skills, tools, and opportunities to scale globally through WE-Elevate Nigeria."
        />
        <meta
          property="og:image"
          content="https://shecluded-medias.s3.us-east-2.amazonaws.com/Hero-Image.png"
        />
        <meta property="og:site_name" content="Shecluded" />

        {/* ---------- Twitter Card ---------- */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="WE-Elevate Nigeria | Empowering Women Entrepreneurs"
        />
        <meta
          name="twitter:description"
          content="Join WE-Elevate Nigeria to gain digital, financial, and entrepreneurial skills to grow your business globally."
        />
        <meta
          name="twitter:image"
          content="https://shecluded-medias.s3.us-east-2.amazonaws.com/Hero-Image.png"
        />
        <meta name="twitter:site" content="@Shecluded" />

        {/* ---------- Structured Data (JSON-LD for Google Rich Results) ---------- */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "WE-Elevate Nigeria | Empowering Women Entrepreneurs | Shecluded",
            "url": "https://shecluded.com/we-elevate",
            "description": "WE-Elevate Nigeria empowers women-led MSMEs with digital, financial, and entrepreneurial skills to scale globally. Apply now to join the next cohort.",
            "publisher": {
              "@type": "Organization",
              "name": "Shecluded",
              "url": "https://shecluded.com",
              "logo": {
                "@type": "ImageObject",
                "url": "https://shecluded.com/logo.png"
              }
            },
            "sponsor": [
              {
                "@type": "Organization",
                "name": "NITDA",
                "url": "https://nitda.gov.ng"
              },
              {
                "@type": "Organization",
                "name": "Digital Cooperation Organization (DCO)",
                "url": "https://www.dco.org"
              }
            ],
            "inLanguage": "en-NG"
          }
        `}</script>
      </Helmet>
      <NavBar />
      <Hero />
      <WeElevateFAQ />
      <Footer />
    </>
  );
}
